/**
 * お問い合わせ用のロジック
 */
export const useInquiry = () => {
  /**
   * お問い合わせフォームを別タブで表示する
   */
  const openInquiryFormInNewTab = async () => {
    // お問い合わせ用のGoogleFormのURLを環境変数から取得する
    const inquiryFormUrl = useRuntimeConfig().public.inquiryUrl;

    window.open(inquiryFormUrl, '_blank');
  };

  return {
    openInquiryFormInNewTab,
  };
};
